$(function(){
  $(document).on('change', 'select#purpose_id', function(e){
    if ($(this).find('option:selected').text() == 'Other - identify the specific crimes being investigated in the space below'){
      $('.other-purpose-box').removeClass('hidden');
    } else {
      $('.other-purpose-box').addClass('hidden');
    }
  });
});
